import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import logo from '../../../assets/plates/header-logo.png';
import { GET_ME } from '../../graphql/queries';
import { isProAccount } from '../../utils/workoutLock';
import { useAppOnPhone } from '../../utils/useAppOnPhone';
import { FloatingHeader } from './FloatingHeader';
import { ThemeToggle } from './ThemeToggle';

// The app's header on phones: pinned to the top of every app page but the guided session, with the brand, the theme
// switch and the account. Desktop has the side rail instead, which carries the same three
const BarHeader = () => {
  const { t } = useTranslation();
  // Already loaded by the page underneath
  const { data } = useQuery(GET_ME, { fetchPolicy: 'cache-first' });
  const me = data?.me;
  const initial = (me?.name || '?').trim().charAt(0).toUpperCase();
  // A hairline under it once the page scrolls beneath
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 4);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`mt-root mt-app-header${isScrolled ? ' is-scrolled' : ''}`}>
      <div className="mt-app-header__inner">
        <Link className="mt-app-header__brand" to="/dashboard">
          <img className="mt-app-header__logo" src={logo} alt="" />
          <span className="mt-app-header__wordmark">{t('appName')}</span>
        </Link>
        <span className="mt-app-header__actions">
          <ThemeToggle className="mt-app-header__theme" />
          <Link className="mt-app-header__avatar" to="/account" aria-label={t('pages.Dashboard.home.avatarLabel')}>
            {initial}
            {/* PRO rides on the avatar, as it does on the desktop rail */}
            {isProAccount(me) && (
              <span className="mt-app-header__pro" aria-hidden="true">
                {t('pages.Dashboard.proPlan')}
              </span>
            )}
          </Link>
        </span>
      </div>
    </header>
  );
};

// The installed app on a phone has no bar: round buttons float over the page (owner decision 30/10/2026)
export const AppHeader = () => (useAppOnPhone() ? <FloatingHeader /> : <BarHeader />);
